import * as React from 'react';

export interface SubheaderProps {
  title: React.ReactNode;
  suffix?: React.ReactNode;
  dataHook?: string;
  skin?: SubheaderSkin;
}

export type SubheaderSkin = 'standard' | 'neutral';
/**
 * @deprecated Card.Subheader is deprecated and will be removed in the next major version. Please use SectionHeader instead.
 */
export default class Subheader extends React.PureComponent<SubheaderProps> {}
